import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Jobsite',
    field: 'jobsite',
    filter: 'text',
    searchable: true,
    navigate: true,
  },
  {
    title: 'Lot/Unit#',
    field: 'unitName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Builder Job Number',
    field: 'jobNumber',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Address',
    field: 'address',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Customer',
    field: 'customerName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Office',
    field: 'officeName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Project',
    field: 'projectName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Project Code',
    field: 'projectCode',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Project Type',
    field: 'projectType',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Community Type',
    field: 'communityType',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Building',
    field: 'buildingName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Fee Owner',
    field: 'feeOwner',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Floor',
    field: 'floor',
    filter: 'numeric',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'status',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Work Orders',
    field: 'workOrderCount',
    filter: 'numeric',
    searchable: true,
  },
];
